/* eslint-disable no-param-reassign */
import React, { Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Popconfirm, Select, Checkbox, Switch,
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import ResourceActions from '@Actions/production/resourceActions';
import ProcessActions from '@Actions/production/processActions';
import SelectResourceGroup from '@Components/Common/SelectResourceGroup';
import H3FormInput from '@Uilib/h3FormInput';
import './style.scss';
import SelectSeller from '@Components/Common/SelectSeller';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faUser } from '@fortawesome/free-solid-svg-icons';
import PRZSelect from '../../../../../Common/UI/PRZSelect';

const { Option } = Select;
/**
 *
 */
const ProductionRoute = ({
  data, loading, tenantId, user, handleRouteChange, getResourceLoading, getResourceGroup, handleDelete, rawMaterials, finishedGoods
}) => {
  useEffect(() => {
    getResourceGroup(user?.tenant_info?.org_id);
  }, [tenantId]);

  const productRouteColumns = [
    {
      title: 'Step#',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => ({
        children: (<Fragment>
          {!record?.fg_product ? (
            <div className="route-step__number">
              {record?.step_number}
            </div>
          ) : (
            <div className="prl-table__fg-name" style={{ padding: '5px 0px' }}>
              <div>
                <Fragment>
                  {`#${record?.fg_product?.internal_sku_code} ${record?.fg_product?.product_sku_name}`}
                </Fragment>
              </div>
              <div className="prl-table__fg-actions">
                <Checkbox
                  checked={record?.is_sequential}
                  onChange={() => handleRouteChange(record?.fg_product?.tenant_product_id, record?.key, 'is_sequential', !record?.is_sequential)}
                  className="mo-form__input-row__input"
                >
                  Execute in Sequence
                </Checkbox>
                <Checkbox
                  checked={record?.is_time_tracked}
                  onChange={() => handleRouteChange(record?.fg_product?.tenant_product_id, record?.key, 'is_time_tracked', !record?.is_time_tracked)}
                  className="mo-form__input-row__input"
                >
                  Enable Time Tracking
                </Checkbox>
              </div>
            </div>
          )}
        </Fragment>),
      }),
      onCell: (item) => {
        if (item?.fg_product) {
          return { colSpan: 7 };
        }
        return {};
      },
      fixed: 'left',
      width: '30px',
    },
    {
      title: 'Process Name',
      width: '240px',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => (
        <div style={{ width: '230px', display: 'flex', flexDirection: 'column' }}>
          <input
            value={record.process_name}
            onChange={(e) => handleRouteChange(record?.fg_tenant_product_id, record?.key, 'process_name', e.target.value)}
            className="mo-pr-table__process-name"
            placeholder="add description of this item.."
            maxLength="512"
            style={{ padding: '0px 8px', width: '220px' }}
          />
          <textarea
            value={record.remarks}
            onChange={(e) => handleRouteChange(record?.fg_tenant_product_id, record?.key, 'remarks', e.target.value)}
            className="mo-pr-table__remarks"
            placeholder="add description of this item.."
            maxLength="512"
            style={{ padding: '0px 8px', width: '220px' }}
          />
        </div>
      ),
      onCell: (item) => {
        if (item?.fg_product) {
          return { colSpan: 0 };
        }
        return {};
      },
      fixed: 'left',
    },
    {
      title: 'Work Center',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      width: '240px',
      render: (text, record) => (
        <div style={{ width: '230px' }}>
          <div className="mo-pr_input-container mo-pr_input-container-block">
            <Switch
              checkedChildren={<FontAwesomeIcon icon={faUser} />}
              unCheckedChildren={<FontAwesomeIcon icon={faHouse} />}
              checked={record?.is_subcontractor}
              onChange={() => handleRouteChange(record?.fg_tenant_product_id, record?.key, 'is_subcontractor', !record?.is_subcontractor)}
              style={{
                marginBottom: '5px',
              }}
            />
            {!record?.is_subcontractor ? (
              <SelectResourceGroup
                selectedResourceGroup={record?.machine_resource_group}
                onChange={(value) => handleRouteChange(record?.fg_tenant_product_id, record?.key, 'machine_resource_group', value)}
                resourceType="MACHINE"
                dropdownWidth="100%"
                height="auto"
                noApiCall
              />
            ) : (
              <SelectSeller
                onChange={(value) => handleRouteChange(record?.fg_tenant_product_id, record?.key, 'subcontractor_seller_id', value?.seller_id)}
                selectedSeller={record?.subcontractor_seller_id}
                tenantId={user?.tenant_info?.tenant_id}
                notRequired
                isSubcontractor
                hideTitle
                inputClassName="NANA"
                placeholder="Select subcontractor"
                mapSellerId
              />
            )}
          </div>
        </div>
      ),
      onCell: (item) => {
        if (item?.fg_product) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
    {
      title: 'Required RM',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => (
        <div className="mo-pr_input-container">
          <PRZSelect
            mode="multiple"
            value={record?.rm_lines?.map((item) => item?.product_sku_id)}
            onChange={(value) => handleRouteChange(record?.fg_tenant_product_id, record?.key, 'rm_lines', value?.map((item) => ({
              product_sku_id: item,
              product_sku_name: rawMaterials?.[record?.fg_tenant_product_id]?.find((i) => i == item)?.product_sku_name,
              is_mandatory: true,
            })))}
            className="input"
            showSearch
          >
            {rawMaterials?.[record?.fg_tenant_product_id]
              ?.filter((item) => !item?.child_bom_lines?.length)
              ?.map((item) => (
                <Option key={item?.product_sku_id} value={item.product_sku_id}>
                  {`${item?.product_info?.internal_sku_code} ${item?.product_info?.ref_product_code ? ` - ${item?.product_info?.ref_product_code}` : ''} ${item?.product_info?.product_sku_name}`}
                </Option>
              ))}
          </PRZSelect>
        </div>
      ),
      onCell: (item) => {
        if (item?.fg_product) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
    {
      title: 'Fixed Charge',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      width: '120px',
      render: (record) => (
        <div style={{ width: '110px' }}>
          <H3FormInput
            value={record?.fixed_charge}
            onChange={(event) => handleRouteChange(record?.fg_tenant_product_id, record?.key, 'fixed_charge', event.target.value)}
            type="number"
            containerClassName="orgInputContainer mo-pr_input-container"
            inputClassName="orgFormInput"
          />
        </div>
      ),
      onCell: (item) => {
        if (item?.fg_product) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
    {
      title: 'Per Unit Charge',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      width: '120px',
      render: (record) => (
        <div style={{ width: '110px' }}>
          <H3FormInput
            value={record?.unit_charge}
            onChange={(event) => handleRouteChange(record?.fg_tenant_product_id, record?.key, 'unit_charge', event.target.value)}
            type="number"
            containerClassName="orgInputContainer mo-pr_input-container"
            inputClassName="orgFormInput"
          />
        </div>
      ),
      onCell: (item) => {
        if (item?.fg_product) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
    {
      title: 'Est. Lead Time (min)',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      width: '120px',
      render: (record) => (
        <div style={{ width: '110px' }}>
          <H3FormInput
            value={record?.lead_time_in_min}
            onChange={(event) => handleRouteChange(record?.fg_tenant_product_id, record?.key, 'lead_time_in_min', event.target.value || null)}
            type="number"
            containerClassName="orgInputContainer mo-pr_input-container"
            inputClassName="orgFormInput"
          />
        </div>
      ),
      onCell: (item) => {
        if (item?.fg_product) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
    {
      title: ' ',
      width: '40px',
      render: (text, record) => (
        <Fragment>
          <Popconfirm
            title="Are you sure you want to remove this step?"
            onConfirm={() => handleDelete(record.fg_tenant_product_id, record.bom_route_line_id)}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <div className="create-mo-bp__delete-line-button">
              <CloseOutlined />
            </div>
          </Popconfirm>
        </Fragment>
      ),
      onCell: (item) => {
        if (item?.fg_product) {
          return { colSpan: 0 };
        }
        return {};
      },
    },
  ];

  const getDataSource = () => {
    if (data) {
      return JSON.parse(JSON.stringify(data));
    }
    return [];
  };

  return (
    <Fragment>
      <div className="prl-table-wrapper">
        <Table
          bordered
          loading={loading || getResourceLoading}
          showHeader
          size="small"
          columns={productRouteColumns}
          dataSource={getDataSource()}
          pagination={false}
        />
      </div>

    </Fragment>
  );
};

/**
 *
 * @param UserReducers
 * @param PurchaseOrderReducers
 * @return {{updateCustomPurchaseOrderLoading: *, selectedPurchaseOrder, user}}
 */
const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, OfferReducers, ResourceReducers, ProcessReducers,
}) => ({
  user: UserReducers.user,
  updateCustomPurchaseOrderLoading: PurchaseOrderReducers.updateCustomPurchaseOrderLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  getOfferByTenantSkuLoading: OfferReducers.getOfferByTenantSkuLoading,
  resources: ResourceReducers.resources,
  getResourceLoading: ResourceReducers.getResourceLoading,
  processes: ProcessReducers.processes,
  getProcessesLoading: ProcessReducers.getProcessesLoading,
});

/**
 *
 * @return {{}}
 */
const mapDispatchToProps = (dispatch) => ({
  getResourceGroup: (orgId) => dispatch(ResourceActions.getResourceGroup(orgId)),
  getProcesses: (orgId, page, limit, searchKeyword) => dispatch(ProcessActions.getProcesses(orgId, page, limit, searchKeyword)),
});

ProductionRoute.propTypes = {
  user: PropTypes.any,
  loading: PropTypes.bool,
  handleDelete: PropTypes.func,
  updateData: PropTypes.func,
  data: PropTypes.any,
  finishedGoods: PropTypes.any,
  rawMaterials: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductionRoute));
